<template>
  <el-container v-loading="loading">
    <el-header>
      <div class="nav-header">
        <el-row>
          <el-col :span="16">
            <span class="title" v-text="title"></span>
            <span class="sub-title" v-text="subTitle"></span>
            <el-tag type="danger">变更申请</el-tag>
          </el-col>
          <el-col :span="8">
            <div class="layout-right">
              <el-button @click="handleClose">关闭返回</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-header>
    <el-main>
      <el-alert
        show-icon
        description="申请变更模块是用在会议前备案完成以后，在开会的时候，有部分专家需要调整。"
        type="info"
      ></el-alert>
      <Base ref="Base" @set-title="handleTitle" :isChange="true"></Base>
      <div class="mt10"><batch ref="Batch" :isChange="true"></batch></div>
    </el-main>
  </el-container>
</template>

<script>
import Base from '@/views/gains/reviews/components/Base.vue';
import Batch from '@/views/gains/reviews/components/Batch.vue';

export default {
  data() {
    return {
      loading: false,
      title: '...',
      subTitle: ''
    };
  },
  components: {
    Base,
    Batch
  },
  methods: {
    handleClose() {
      window.close();
    },
    handleTitle(para) {
      this.title = para.title;
      this.subTitle = para.subTitle;
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-header {
  .layout-right {
    padding: 10px;
  }
}
</style>
